<template>
  <div>
    <p>
      <span>
        {{ $t('receivablePayable.total') }}{{ $t('receivablePayable.totalCount') }}
        <span style="color: red;">{{ params.totalCount || 0 }}</span>
        {{ $t('receivablePayable.unit') }}{{ $t('receivablePayable.data') }}, {{ $t('receivablePayable.currentReview') }}
        <span style="color: red;">{{ params.unPaidCount || 0 }}</span>
        {{ $t('receivablePayable.unit') }}{{ $t('receivablePayable.unreconciledData') }}
      </span>
    </p>
    <el-form
      ref="examineForm"
      size="small"
      :model="examineForm"
    >
      <!--审核-->
      <el-form-item
        :label="$t('receivablePayable.examine') + '：'"
        prop="examine"
        :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
      >
        <el-radio-group v-model="examineForm.examine">
          <div style="margin-bottom: 5px;">
            <!--通过（多条数据合并生成一个收款单）-->
            <el-radio :label="0">{{ $t('receivablePayable.PassMultipleDataMergingToGenerateOneReceipt') }}</el-radio>
          </div>
          <div style="margin-bottom: 5px;">
            <!--通过（多条数据生成多个收款单）-->
            <el-radio :label="1">{{ $t('receivablePayable.GenerateMultipleReceiptsThrough') }}</el-radio>
          </div>
          <div>
            <!--不通过-->
            <el-radio :label="2">{{ $t('receivablePayable.DoesNotPass') }}</el-radio>
          </div>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        :label="$t('receivablePayable.remark') + '：'"
        prop="remark"
        :rules="{ required: examineForm.examine === 2, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
      >
        <el-input v-model="examineForm.remark" type="textarea" :rows="6" />
      </el-form-item>

      <el-form-item style="text-align: end">
        <el-button size="small" @click="cancel">{{ $t('basicData.Cancel') }}</el-button>
        <el-button size="small" type="primary" @click="submit">{{ $t('basicData.determine') }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      examineForm: {
        examine: 2,
        remark: ''
      }
    };
  },
  methods: {
    cancel() {
      this.$emit('close');
      this.clearForm();
    },
    submit() {
      this.$refs['examineForm'].validate((valid) => {
        if (valid) {
          this.$emit('submit', this.examineForm);
          this.clearForm();
        }
      });
    },
    clearForm() {
      this.$refs.examineForm.clearValidate();
    }
  }
};
</script>

